import { render, staticRenderFns } from "./RefundBox.vue?vue&type=template&id=1943a45f&scoped=true&"
import script from "./RefundBox.vue?vue&type=script&lang=js&"
export * from "./RefundBox.vue?vue&type=script&lang=js&"
import style0 from "./RefundBox.vue?vue&type=style&index=0&id=1943a45f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1943a45f",
  null
  
)

export default component.exports